import React from "react";
import ShipmentPackagesTrackingList from "./ShipmentPackagesTrackingList";
import {showContextualMenu} from "../../actions/ViewActions";
import {hasIndividualPackageHandlingCapability} from "../../lib/Couriers";
import {
  requestReplacePackagesForShippingOrder,
  requestChangePackageDeliveryStatusDelivered,
  requestChangePackageDeliveryStatusPickedUp,
} from "../../actions/ShippingApiActions";
import {connect} from "react-redux";

// Key used to retrieve a package from a list/table
// Has to be set in ShipmentPackagesTrackingList > setTrackingWithPackages
export const TRACKING_ITEM_KEY = "packageId";


const TrackingList = (props) => {
  // Callback for context menu used in the table, per row


  // ---- This needs REPLACING to handle multiple package ids ----

  function handleItemContextMenuClick(itemData, x, y) {
    const items = []

    if (hasIndividualPackageHandlingCapability(props.courierId)) {
      items.push({label: "Mark as Picked Up", cmd: requestChangePackageDeliveryStatusPickedUp(props.orderId, itemData.get("trackingNr"))})
      items.push({label: "Mark as Delivered", cmd: requestChangePackageDeliveryStatusDelivered(props.orderId, itemData.get("trackingNr"))})
    } else {
      items.push({label: "No actions available", disabled: true});
    }
  
    props.showContextualMenu(items, x, y);
  }

  function handleReplacePackages(packageIds) {
    props.requestReplacePackagesForShippingOrder(props.orderId, packageIds);
  }
  
  return (
    <ShipmentPackagesTrackingList {...props}
      courierId={props.courierId}
      trackingItemKey={TRACKING_ITEM_KEY}
      useShipmentTracking={props.courierId === "ups"}
      onItemContextMenuClick={handleItemContextMenuClick}
      onReplacePackages={handleReplacePackages}
    />
  );
}


export default connect(null, {
  showContextualMenu,
  requestReplacePackagesForShippingOrder,
  requestChangePackageDeliveryStatusDelivered,
  requestChangePackageDeliveryStatusPickedUp
})(TrackingList);